import { render, staticRenderFns } from "./ModalSurgeryGrid.vue?vue&type=template&id=4faf759b&scoped=true"
import script from "./ModalSurgeryGrid.vue?vue&type=script&lang=ts"
export * from "./ModalSurgeryGrid.vue?vue&type=script&lang=ts"
import style0 from "./ModalSurgeryGrid.vue?vue&type=style&index=0&id=4faf759b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf759b",
  null
  
)

export default component.exports